// events
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbLoader from "../webb/webb-loader";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { CreateToken } from "../../services/srvc-tokens-realm";

import CredsFileSaveFirebase from "../../services/srvc-creds-fbse";

export default function WorkCreateModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();

  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [form, setForm] = useState(false);
  const [text, setText] = useState('');
  
  const [cred, setCred] = useState([])
  const [sort, setSort] = useState([])

  const [file, setFile] = useState('')
  const [data, setData] = useState({
    name: '',
    memo: '',
    form: 'work',
    sort: '',
    avtr: '',
    link: ''
  })

  // useEffect for form validation
  useEffect( () => {
    setForm(false);
    if (data.name!=='' && data.form!=='' && data.link!=='' && file!=='') 
      setForm(true);
  },[data]);

  const SetFileData = async(data) => {
    console.log ('file: ',data);
    
    const reader = new FileReader();
    reader.onloadend = () => {
      // use a regex to remove data url part
      const base64String = reader.result
      .replace("data:", "")
      .replace(/^.+,/, "");
  
      // log to console
      console.log(base64String);
      setFile(base64String);
    };
    reader.readAsDataURL(data);

  }

  const SetFileLink = async(data) => {
    console.log ('link: ',data);
    handleChange("link", data);
  }

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();    

    setLoading(true)
    const res = await CreateToken({
      data: { ...data, avtr: file }, 
      user: asset.usid
    })
    
    setLoading(false)
    console.log (res)
    if (res.data) history.push(`/${UserForm()}/tokens`)
    else alert('Please Try Again')
  };

  if (loading){ return ( <> <WebbLoader /> </> ) }

  return (
  <>
    {/* info */}
    <WebbModuleInfo data={{text: 'Create XRPL NFT Credentials'}}/>

    {/* form */}
    <form onSubmit={handleSubmit}>

      <div className="">

        <div className={`form-group mb-3 ${data.form !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Credential Name  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.name}
            onChange={({ target }) => {handleChange("name", target.value); setText('');}}
            placeholder="Credential Name">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Credential Memo  <FormNeeded /></label>
          <textarea type="text" 
            className="form-control" 
            style={{fontSize:'0.9rem'}} rows="3"
            value={data.memo}
            onChange={({ target }) => {handleChange("memo", target.value); setText('');}}
            placeholder="">
          </textarea>
        </div>

        {/* file */}
        <div className={`mb-3 ${data.form !=='' ? '' : 'd-none'}`}>
          <CredsFileSaveFirebase 
            name = {'123'} 
            file = {SetFileData}
            link = {SetFileLink}
          />
        </div>

      </div>

      {/* actn */}
      <WebbDividerMedium />      
      <div className={`mb-3 ${data.form !=='' ? '' : 'd-none'}`}>
        <div className="d-grid">
          <button className={`btn height-md rounded-pill ${ form ? 'btn-primary back-color-main' : 'btn-primary back-color-main'}`}
            disabled={!form}
          ><small>Create Credential</small>
          </button>
        </div>
      </div>

    </form>


    <WebbDividerMedium/>
    <WebbDividerMedium/>
  </>
  )
}